import { render } from "./SentMsg.vue?vue&type=template&id=3044fd7a"
import script from "./SentMsg.vue?vue&type=script&lang=js"
export * from "./SentMsg.vue?vue&type=script&lang=js"

import "./SentMsg.vue?vue&type=style&index=0&id=3044fd7a&lang=css"
script.render = render

export default script